import * as components from './components';
import * as pages from './pages';
import * as redux from './redux';
import * as api from './api';

export default { api, redux, pages, components };
